<script setup lang="ts">
defineProps<{
  active?: boolean;
}>();
</script>

<template>
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      y="4"
      width="4"
      height="16"
      fill="#AFB6C1"
    >
      <animate
        v-if="active"
        attributeName="y"
        values="4;12;0;4"
        dur="1.25s"
        repeatCount="indefinite"
      />
    </rect>
    <rect
      x="6"
      width="4"
      height="16"
      fill="#AFB6C1"
    >
      <animate
        v-if="active"
        attributeName="y"
        values="0;12;0"
        dur="1.25s"
        repeatCount="indefinite"
      />
    </rect>
    <rect
      x="12"
      y="9"
      width="4"
      height="16"
      fill="#AFB6C1"
    >
      <animate
        v-if="active"
        attributeName="y"
        values="9;0;9"
        dur="1.25s"
        repeatCount="indefinite"
      />
    </rect>
  </svg>
</template>
